import { Box, Button, IconButton, Stepper as MUIStepper, styled, TextField, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

import { GRID_HEADER_BACKGROUND_COLOR, GRID_HEADER_BORDER_COLOR, ROW_HOVER_BACKGROUND_COLOR, WHITE } from "../../../styles/colors";

export const GLAccount = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const GLAccountChild = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-indent: 30px;
`;

export const HeaderRow = styled(Box)(({
  theme
}) => ({
  display: "grid",
  gridTemplateColumns: '95% 4%',
  gap: theme.spacing(1),
  justifyContent: "left",
  alignItems: "center",
  mb: theme.spacing(2),
}));

export const StyledTextfield = styled(TextField)`
  padding: 10px;
  margin-left: 10px;
  fieldset {
    border-radius: 50px;
    border: 1px solid #919195;
  }

  input {
    width: 100%;
    padding-right: 10px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    padding-left: 0px !important;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid #919195;
  }
`;

export const BulkMappingWrapper = styled(Box)`
  background-color: #ECEEF3;
  padding: 15px 35px;
`;

export const SelectBox = styled(Box)`
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 5px;

  & .MuiSelect-select {
    width: 200px;
    padding: 0;
  }

  & .MuiFormControl-root {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  & .MuiOutlinedInput-root {
    background-color: ${WHITE};
    padding-left: 10px;
  }

  &	.MuiInputLabel-formControl .MuiInputLabel-asterisk {
    color: red;
  }

  & .MuiButton-root {
    width: 100px;
  }

  & .MuiButton-root, .MuiTypography-root {
    margin: 0 10px;
  }

  & .MuiMenuItem-root {
    min-width: 100%
  }
`;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const SelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

export const StyledProgress = styled(Box)`
  &.MuiBox-root {
    margin: 10px;
    display: flex;
    align-items: center;
    width: 65%;
  }

  & .MuiLinearProgress-root.MuiLinearProgress-determinate {
    height: 12px;
    width: 100%;
  }

  & .MuiTypography-root:nth-of-type(1) {
    width: 160px;
    margin: 0 20px 0 0;
  }

  & .MuiTypography-root:nth-of-type(2) {
    width: 250px;
    margin: 0 20px;
  }
`;

export const StyledDataGridPro = styled(DataGridPro)`
  margin-top: 10px;
  margin-bottom: 25px;

  border: 1px solid transparent;
  border-radius: 0;

  
  .MuiDataGrid-row.Mui-hovered {
    background-color: ${ROW_HOVER_BACKGROUND_COLOR};
  }

  .MuiDataGrid-cell:focus {
    outline: none;
  }

  .MuiDataGrid-cell:focus-within {
    outline: none;
  }

  .MuiDataGrid-columnHeaders {
    background-color: ${GRID_HEADER_BACKGROUND_COLOR};
    border-top: 1px solid ${GRID_HEADER_BORDER_COLOR};
    border-bottom: 1px solid ${GRID_HEADER_BORDER_COLOR};
    min-height: 30px !important;
    max-height: 30px !important;
    line-height: 30px !important;
  }

  .MuiDataGrid-columnHeader(:not(:first-of-type)) {
    background-color: ${GRID_HEADER_BACKGROUND_COLOR};
    border: 1px solid ${GRID_HEADER_BORDER_COLOR};
    padding: 1px 10px;
  }

  .MuiDataGrid-columnHeader:focus {
    outline: none;
  }

  .MuiDataGrid-columnSeparator {
    color: transparent;
  }

  .MuiDataGrid-columnSeparator:hover {
    color: transparent;
  }

  .MuiDataGrid-iconButtonContainer {
    visibility: visible;
    width: auto;
  }

  .MuiDataGrid-pinnedColumns {
    box-shadow: -6px 0px 12px -7px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: -6px 0px 12px -7px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: -6px 0px 12px -7px rgba(0, 0, 0, 0.5);
  }

  & .MuiDataGrid-cell[data-field="transactionTypeName"] {
    padding: 0;
  }
`;

export const TypographyBold = styled(Typography)`
  &.MuiTypography-body1 {
    font-weight: 700;
  }
`;

export const PanelBox = styled(Box)`
  padding: 30px;
`;

export const Stepper = styled(MUIStepper)`
  margin: 20px 0;
`;

export const PlatformButton = styled(Button)(({
  theme
}) => ({
  height: '100px',
  width: '100%',
  margin: '20px 0',

  '&.selected': {
    border: `1px solid #007aff`,
  },
  'img': {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
  }
}));

export const PanelDescription = styled(Typography)`
  margin: 30px 0;
`;

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  minWidth: "47px",
  [`&:hover`]: {
    backgroundColor: "#4aa1ff",
    color: "#FFFFFF",
    border: "0px",
  }
}));

export const StyledTooltip = styled(({
  className, ...props
}: TooltipProps) => (
  <Tooltip {...props} arrow classes={{
    popper: className
  }} />
))(({
  theme
}) => ({
  [`& .MuiTypography-root`]: {
    textAlign: "center",
    marginBottom: "10px"
  }
}));

export const DisconnectButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.common.white,
  fontSize: theme.typography.pxToRem(16),
  textDecoration: 'underline',
  [`&:hover`]: {
    backgroundColor: 'transparent',
    color: "#FFFFFF",
    border: '0px',
    textDecoration: 'underline',
  }
}));
